<style>
    .tvl_layer a, .tvl_layer a:hover {
        text-decoration: none !important
    }

    .tvl_layer div {
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }

    .tvl_layer_mask {
        position: fixed;
        z-index: 998;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0)
    }

    .tvl_layer {
        position: fixed;
        z-index: 999;
        left: 0;
        bottom: 0;
        width: 100%;
        background: rgba(0, 0, 0, .8);
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
    }

    .tvl_layer .tvl_bd {
        padding: 16px 20px 0
    }

    .tvl_layer .tvl_login_tit {
        font-size: 15px;
        line-height: 30px;
        color: #fff;
        text-align: center;
        margin-bottom: 8px
    }

    .tvl_layer .tvl_login_btn {
        padding: 0 42px 3px
    }

    .tvl_layer .tvl_login_wx, .tvl_layer .tvl_login_qq {
        display: block;
        width: 100%;
        text-align: center;
        line-height: 38px;
        font-size: 14px;
        color: #fff;
        border-radius: 19px;
        margin-bottom: 15px
    }

    .tvl_layer .tvl_login_wx {
        background: #2ec637
    }

    .tvl_layer .tvl_login_qq {
        background: #40a5e5
    }

    .tvl_layer .tvl_icon_wx, .tvl_layer .tvl_icon_qq {
        display: inline-block;
        width: 25px;
        height: 21px;
        background-image: url(//vm.gtimg.cn/tencentvideo/vstyle/mobile/vip/style/app_v2/img/tvl_layer/sprite_icon.png?d=0623&max_age=31104000);
        background-repeat: no-repeat;
        background-position: 9999em 9999em;
        background-size: 60px;
        vertical-align: middle;
        margin-right: 4px;
        position: relative;
        top: -2px
    }

    .tvl_layer .tvl_icon_wx {
        background-position: 0 0
    }

    .tvl_layer .tvl_icon_qq {
        background-position: -30px 0
    }

    .tvl_layer .tvl_btn {
        position: relative;
        overflow: hidden
    }

    .tvl_layer .tvl_btn:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        border-bottom: 1px solid #3f4041;
        -webkit-transform: scaleY(.5);
        -webkit-transform-origin: 0 0
    }

    .tvl_layer .tvl_btn_a, .tvl_layer .tvl_btn_b {
        position: relative;
        float: left;
        display: block;
        width: 100%;
        font-size: 15px;
        line-height: 50px;
        text-align: center
    }

    .tvl_layer .tvl_btn_a {
        color: #fff
    }

    .tvl_layer .tvl_btn_b {
        color: #bf954b
    }

    .tvl_layer .tvl_btn_2 .tvl_btn_a, .tvl_layer .tvl_btn_2 .tvl_btn_b {
        width: 50%
    }

    .tvl_layer .tvl_btn_2 .tvl_btn_b:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        border-left: 1px solid #3f4041;
        -webkit-transform: scaleX(.5);
        -webkit-transform-origin: 0 0
    }

    .tvl_layer .tvl_account_tit {
        position: relative;
        margin: 0 -10px;
        font-size: 15px;
        line-height: 30px;
        color: #fff;
        text-align: center;
        margin-bottom: 18px
    }

    .tvl_layer .tvl_account_tit .tvl_change {
        position: absolute;
        right: 0;
        top: 5px;
        color: #8d8d8d;
        line-height: 20px;
        border-bottom: 1px solid #8d8d8d
    }

    .tvl_layer .tvl_account_tit .tvl_name {
        display: block;
        padding-right: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap
    }

    .tvl_layer .tvl_account_tit .tvl_name.no_padding {
        padding-right: 0
    }

    .tvl_layer .tvl_account_nochange .tvl_name {
        display: block;
        padding-right: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap
    }

    .tvl_layer .tvl_account_nochange .tvl_change {
        display: none
    }

    .tvl_layer .tvl_avater {
        width: 55px;
        height: 55px;
        margin: 0 auto;
        border: 2px solid #8d8d8d;
        background: #fff;
        border-radius: 50%;
        margin-bottom: 34px
    }

    .tvl_layer .tvl_avater_img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%
    }
</style>

<template>
    <div>
        <div class="tvl_layer tvl_layer_account" :class="{none: !show}" v-if="!changeAccount">
            <div class="tvl_bd">
                <div class="tvl_account">
                    <div class="tvl_account_tit">
                <span class="tvl_name" v-if="type==2" :class="{no_padding: !showChange}">
                    确认领取到QQ账号{{useNick ? nick : id}}吗
                </span>
                        <span class="tvl_name" v-if="type==1" :class="{no_padding: !showChange}">
                    确认领取到微信账号{{nick}}吗
                </span>
                        <a class="tvl_change" href="javascript:;" :class="{none: !showChange}" @click="change">切换账号</a>
                    </div>
                    <div class="tvl_account_avater">
                        <div class="tvl_avater">
                            <img class="tvl_avater_img"
                                 :src="headurl?headurl:'//i.gtimg.cn/qqlive/images/20150608/avatar.png'" alt="用户头像">
                        </div>
                    </div>
                </div>
                <div class="tvl_btn tvl_btn_2">
                    <a class="tvl_btn_a" href="javascript:;" @click="handleCancel">取     消</a>
                    <a class="tvl_btn_b" href="javascript:;" @click="handleOk">确     认</a>
                </div>
            </div>
        </div>
        <div class="tvl_layer tvl_layer_login" style="z-index: 100;" v-else>
            <div class="tvl_bd">
                <div class="tvl_login">
                    <div class="tvl_login_tit">选择你要领取的帐号</div>
                    <div class="tvl_login_btn">
                        <a class="tvl_login_qq" href="javascript:;" @click="loginByQQ"><i
                                class="tvl_icon_qq"></i>QQ登录</a>
                        <a class="tvl_login_wx" href="javascript:;" @click="loginByWx"><i
                                class="tvl_icon_wx"></i>微信登录</a>
                    </div>
                </div>
                <div class="tvl_btn">
                    <a class="tvl_btn_a" href="javascript:;" style="z-index: 100" @click="cancelChange">取     消</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import login from '@tencent/vft-common/login'
    var _options = {
        show: false,
        showChange: true, //默认展示切换按钮
        changeAccount: false,
        useNick: false,
        type: 2,
        headurl: '//i.gtimg.cn/qqlive/images/20150608/avatar.png',
        id: '',
        nick: '',
        onOk: null,

        onCancel: null
    }
    function _isPromisable(v) {
        return v && typeof v == 'object' && v.then && v.catch && $.isFunction(v.then) && $.isFunction(v.catch);
    }
    export default{
        data(){
            return _options
        },
        methods: {
            handleOk() {
                this._handle(this.onOk);
            },
            handleCancel() {
                this._handle(this.onCancel);
            },
            _handle(callback) {
                var result;
                if (!callback) {
                    this.show = false;
                    return;
                }
                result = callback();

                if (_isPromisable(result)) {
                    result.then(data => {
                        this.show = false;
                    });
                    return;
                }
                if (result !== false) {
                    this.show = false;
                }
            },
            close() {
                this.show = false;
            },
            change () {
                this.changeAccount = true
            },
            loginByQQ () {
                login.openLogin({
                    type: 'qq'
                })
                return false
            },
            loginByWx () {
                login.openLogin({
                    type: 'wx'
                })
                return false
            },
            cancelChange (){
                this.changeAccount = false
            }
        },
        install (Vue) {
            Vue.prototype.popupConfirmAccount = (
                (options = {
                    type: 2,
                    headurl: '//i.gtimg.cn/qqlive/images/20150608/avatar.png',
                    id: '',
                    nick: '',
                    onOk: null,
                    onCancel: null
                }) => {
                    $.extend(_options, options, {show: true});
                }
            );
        }
    }
</script>
